// client/src/components/plataforma/contas/ContaPublicPageSettings.js - CORRIGIDO
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PublicPageSettingsPanel from './PublicPageSettingsPanel';
import { useAccountById } from '../../../hooks/useAccounts';
import { Loader2, ArrowLeft } from 'lucide-react';

const ContaPublicPageSettings = () => {
    const { id: contaId } = useParams();
    const navigate = useNavigate();
    const { data: accountDetails, isLoading } = useAccountById(contaId);

    // ✅ CORREÇÃO: Volta para página anterior ou início
    const handleBack = () => {
        navigate(-1); // Volta para página anterior
        // OU se preferir específico: navigate('/');
    };

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-64">
                <Loader2 className="animate-spin text-indigo-600" size={40} />
            </div>
        );
    }

    if (!accountDetails) {
        return (
            <div className="p-8 text-center text-red-500">
                Erro: Conta não encontrada.
            </div>
        );
    }

    return (
        <div className="page-management-container">
            <div className="page-header">
                <div className="flex items-center gap-4">
                    {/* ✅ CORREÇÃO: Botão voltar flexível */}
                    <button 
                        onClick={handleBack}
                        className="action-button action-button-secondary"
                    >
                        <ArrowLeft size={16} className="icon" />
                        Voltar
                    </button>
                    <h1 className="page-title">
                        Página Pública - {accountDetails.name}
                    </h1>
                </div>
            </div>
            
            <PublicPageSettingsPanel 
                accountId={contaId}
                onBack={handleBack}
            />
        </div>
    );
};

export default ContaPublicPageSettings;